import lottie from 'lottie-web/build/player/lottie_light.js';

function lottieAccordionInit() {
	// remove window.lottie check
	const items = document.querySelectorAll('[data-target="accordion"]');

	if ( items.length === 0 ) return;

	items.forEach(item => {
		const el = item.querySelector('.lottie--accordion-icon');
		const header = item.querySelector('[data-target="accordion-trigger"]');
		if (!el || !header) return;

		const path = el.dataset.lottiePath;
		let animation;
		try {
			animation = lottie.loadAnimation({ // use imported lottie
				container: el,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: path
			});
		} catch (err) {
			console.warn(err);
			return;
		}
		animation.goToAndStop(0, true);

		// Store animation instance on the element for easy access
		item._lottieAnimation = animation;

		header.addEventListener('click', () => {
			const willOpen = !item.classList.contains('open');

			/*
			// Close all other open items
			items.forEach(otherItem => {
				if (otherItem !== item && otherItem.classList.contains('open')) {
					otherItem.classList.remove('open');
					const anim = otherItem._lottieAnimation;
					if (anim) {
						anim.setDirection(-1);
						anim.play();
					}
				}
			});
			*/

			// Toggle clicked item
			if (willOpen) {
				item.classList.add('open');
				animation.setDirection(1);
				animation.play();
			} else {
				item.classList.remove('open');
				animation.setDirection(-1);
				animation.play();
			}
		});
	});
}

function lottieInit() {
	lottieAccordionInit();
}

export { lottieInit };
